export default __webpack_public_path__ + "static/get-it-on-fdroid-55b96c7069d49892f85c4e92437560de.png";